<template>
  <div class="page-login">
    <a-spin v-if="!hasLogin" class="login-status-spin"> </a-spin>
    <bind-form v-if="!hasBinding" action="bind" loginType='thirdParty' type="mobile" :event="1" :codeToken="codeToken"></bind-form>
  </div>
</template>

<script>
import { thirdPartyOauth, thirdPartySourceLogin } from '@/api/login'
import bindForm from '../binding/components/Form'
import './index'

export default {
  data () {
    return {
      hasLogin: false,
      hasBinding: true,
      codeToken: '',
      thirdpartyOauth: null
    }
  },
  created () {
    const userAppConfig = window.top.UserAppConfig || {}
    this.thirdpartyOauth = userAppConfig.thirdpartyOauth || {}
    if (this.thirdpartyOauth && this.thirdpartyOauth.appId && this.thirdpartyOauth.code) {
      this.autoThirdPartyAuthorize()
    } else {
      this.$message.error('参数缺失，即将返回上一页')
      setTimeout(() => {
        history.go(-1)
      }, 2000)
    }
  },
  methods: {
    // 第三方公众号自动授权
    async autoThirdPartyAuthorize () {
      const { thirdpartyOauth } = this
      try {
        const data = await thirdPartyOauth({
          redirectUri: thirdpartyOauth.redirectUrl,
          source: thirdpartyOauth.source || 'WECHAT_MP',
          outAppId: thirdpartyOauth.appId
        })
        this.$ls.set('USER_CENTER_TOKEN', data.token, 2 * 60 * 60 * 1000)
        this.autothirdPartyLogin(data)
      } catch (err) {
        this.$message.error(err.message)
      }
    },
    // 第三方公众号自动登录用于获取openid
    async autothirdPartyLogin (params) {
      const { thirdpartyOauth } = this
      try {
        const bodyData = {
          code: thirdpartyOauth.code,
          state: params.state,
          outAppId: thirdpartyOauth.appId
        }
        const source = thirdpartyOauth.source || 'WECHAT_MP'
        const data = await thirdPartySourceLogin(bodyData, source)
        this.handleLoginSuccess(data)
      } catch (err) {
        if (err.code === 20002) {
          this.$message.success('您尚未绑定手机号，请先完成绑定')
          this.hasLogin = true
          this.hasBinding = false
        } else if (err.code === 20021) {
          const data = err.data
          this.hasLogin = true
          this.handleLoginSuccess(data)
        } else {
          this.hasLogin = true
          this.$message.error(err.message)
        }
      }
    },
    handleLoginSuccess (data) {
      this.hasLogin = true
      this.$message.success('登录成功')

      window.userAppUserInfo = {
        ...data,
        token: this.$ls.get('USER_CENTER_TOKEN')
      }

      this.$ls.set('USER_CENTER_INFO', data)
      window.top.postMessage('Login::Success', '*')
    }
  },
  components: {
    bindForm
  }
}
</script>
